import theme from "./theme";
var fonts = function fonts(props) {
  return theme(props).fonts;
};
export var serifFont = function serifFont(props) {
  return fonts(props).serif;
};
export var sansSerifFont = function sansSerifFont(props) {
  return fonts(props).sansSerif;
};
var headings = function headings(props) {
  return theme(props).headings;
};
export var headingColor = function headingColor(props) {
  return headings(props).color;
};
var h1 = function h1(props) {
  return headings(props).h1;
};
export var h1FontFamily = function h1FontFamily(props) {
  return h1(props).fontFamily;
};
export var h1FontSize = function h1FontSize(props) {
  return h1(props).fontSize;
};
export var h1FontWeight = function h1FontWeight(props) {
  return h1(props).fontWeight;
};
export var h1Tracking = function h1Tracking(props) {
  return h1(props).tracking;
};
export var h1LineHeight = function h1LineHeight(props) {
  return h1(props).lineHeight;
};
export var h1IsUpperCase = function h1IsUpperCase(props) {
  return h1(props).uppercase;
};
var h2 = function h2(props) {
  return headings(props).h2;
};
export var h2FontFamily = function h2FontFamily(props) {
  return h2(props).fontFamily;
};
export var h2FontSize = function h2FontSize(props) {
  return h2(props).fontSize;
};
export var h2FontWeight = function h2FontWeight(props) {
  return h2(props).fontWeight;
};
export var h2Tracking = function h2Tracking(props) {
  return h2(props).tracking;
};
export var h2LineHeight = function h2LineHeight(props) {
  return h2(props).lineHeight;
};
export var h2IsUpperCase = function h2IsUpperCase(props) {
  return h2(props).uppercase;
};
var h3 = function h3(props) {
  return headings(props).h3;
};
export var h3FontFamily = function h3FontFamily(props) {
  return h3(props).fontFamily;
};
export var h3FontSize = function h3FontSize(props) {
  return h3(props).fontSize;
};
export var h3FontWeight = function h3FontWeight(props) {
  return h3(props).fontWeight;
};
export var h3Tracking = function h3Tracking(props) {
  return h3(props).tracking;
};
export var h3LineHeight = function h3LineHeight(props) {
  return h3(props).lineHeight;
};
export var h3IsUpperCase = function h3IsUpperCase(props) {
  return h3(props).uppercase;
};
var h4 = function h4(props) {
  return headings(props).h4;
};
export var h4FontFamily = function h4FontFamily(props) {
  return h4(props).fontFamily;
};
export var h4FontSize = function h4FontSize(props) {
  return h4(props).fontSize;
};
export var h4FontWeight = function h4FontWeight(props) {
  return h4(props).fontWeight;
};
export var h4Tracking = function h4Tracking(props) {
  return h4(props).tracking;
};
export var h4LineHeight = function h4LineHeight(props) {
  return h4(props).lineHeight;
};
export var h4IsUpperCase = function h4IsUpperCase(props) {
  return h4(props).uppercase;
};
var h5 = function h5(props) {
  return headings(props).h5;
};
export var h5FontFamily = function h5FontFamily(props) {
  return h5(props).fontFamily;
};
export var h5FontSize = function h5FontSize(props) {
  return h5(props).fontSize;
};
export var h5FontWeight = function h5FontWeight(props) {
  return h5(props).fontWeight;
};
export var h5Tracking = function h5Tracking(props) {
  return h5(props).tracking;
};
export var h5LineHeight = function h5LineHeight(props) {
  return h5(props).lineHeight;
};
export var h5IsUpperCase = function h5IsUpperCase(props) {
  return h5(props).uppercase;
};
var h6 = function h6(props) {
  return headings(props).h6;
};
export var h6FontFamily = function h6FontFamily(props) {
  return h6(props).fontFamily;
};
export var h6FontSize = function h6FontSize(props) {
  return h6(props).fontSize;
};
export var h6FontWeight = function h6FontWeight(props) {
  return h6(props).fontWeight;
};
export var h6Tracking = function h6Tracking(props) {
  return h6(props).tracking;
};
export var h6LineHeight = function h6LineHeight(props) {
  return h6(props).lineHeight;
};
export var h6IsUpperCase = function h6IsUpperCase(props) {
  return h6(props).uppercase;
};
var copy = function copy(props) {
  return theme(props).copy;
};
export var copyColor = function copyColor(props) {
  return copy(props).color;
};
export var copyFontFamily = function copyFontFamily(props) {
  return copy(props).fontFamily;
};
export var copyFontSize = function copyFontSize(props) {
  return copy(props).fontSize;
};
export var copyFontWeight = function copyFontWeight(props) {
  return copy(props).fontWeight;
};
export var copyLineHeight = function copyLineHeight(props) {
  return copy(props).lineHeight;
};
export var copyFontSizeSmall = function copyFontSizeSmall(props) {
  return copy(props).smallFontSize;
};
export var copyFontSizeLarge = function copyFontSizeLarge(props) {
  return copy(props).largeFontSize;
};
var link = function link(props) {
  return theme(props).link;
};
export var linkLoud = function linkLoud(props) {
  return link(props).loudColor;
};
export var linkDark = function linkDark(props) {
  return link(props).darkColor;
};
export var linkLight = function linkLight(props) {
  return link(props).lightColor;
};
export var linkDestructive = function linkDestructive(props) {
  return link(props).destructiveColor;
};